import React from "react";
import { useIntl } from "react-intl";
import { useBreakpoints } from "@evidenceb/athena-common/helpers/breakpoints";
import TeacherResourceMiniature from "../../../../../../design-system-components/ResourceMiniature/TeacherResourceMiniature/TeacherResourceMiniature";
import InfoPanelDrawer from "../../../../../../components/Player/InfoPanel/InfoPanelDrawer/InfoPanelDrawer";
import SimpleBar from "simplebar-react";
import { playlistMessages } from "../../EditPlaylist/playlistMessages";
import {
    useResourceSeries,
    useResourceSeriesDispatch,
} from "../../../../../../components/Player/ResourceSeries/Contexts";
import { getLearningItem } from "../../../../../../components/Player/ResourceSeries/utils";
import {
    PlaylistResourceSeriesAdditionalInformation,
    PlaylistResourceSeriesItem,
    PlaylistResourceSeriesRecord,
} from "../playlistResourceSeriesReducer";
import { getPlaylist } from "../playlistResourceSeriesReducer.utils";
import { ResourcePath } from "../../utils";
import { InfoPanelProps } from "../../../../../../interfaces/Player";

import "./InfoPanel.scss";

type Props = InfoPanelProps;

const InfoPanel = ({ getContainer }: Props) => {
    const { isTabletOrSmaller } = useBreakpoints();

    if (isTabletOrSmaller) return null;

    return (
        <InfoPanelDrawer
            getContainer={getContainer}
            className="teacher-playlist-player__info-panel-wrapper"
        >
            <InfoPanelContent />
        </InfoPanelDrawer>
    );
};
export default InfoPanel;

export const InfoPanelContent = () => {
    const intl = useIntl();
    const resourceSeries = useResourceSeries<
        PlaylistResourceSeriesRecord,
        PlaylistResourceSeriesAdditionalInformation
    >();
    const dispatch = useResourceSeriesDispatch();

    if (!resourceSeries.hierarchy) return null;

    const playlist = getPlaylist(resourceSeries);

    return (
        <div className="teacher-playlist-player__info-panel">
            <h3>
                {playlist.learning_items.length}{" "}
                {playlist.learning_items.length > 1
                    ? intl.formatMessage(playlistMessages.resources)
                    : intl.formatMessage(playlistMessages.singleResource)}
            </h3>
            <div className="teacher-playlist-player__list-container">
                <SimpleBar>
                    <ol className="teacher-playlist-player__resources-list">
                        {playlist.learning_items.map((itemId) => {
                            const item = resourceSeries.resources[
                                itemId
                            ] as PlaylistResourceSeriesItem;
                            return (
                                <li key={itemId}>
                                    <TeacherResourceMiniature
                                        path={ResourcePath.fromLearningItem({
                                            learning_item_id: item.id,
                                            ...item,
                                        })}
                                        active={
                                            getLearningItem(resourceSeries)
                                                ?.id === item.id
                                        }
                                        onClick={() => {
                                            dispatch({
                                                type: "goToExercise",
                                                hierarchy: [
                                                    item.id,
                                                    playlist.id,
                                                ],
                                            });
                                        }}
                                    />
                                </li>
                            );
                        })}
                    </ol>
                </SimpleBar>
            </div>
        </div>
    );
};
